
























































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { State, Getter, Mutation } from 'vuex-class';
import { VuexMutation, PayFrequencyValues, Person, Output, OutputContribution, Copy } from '@/types';
import _ from 'lodash';

@Component
export default class OutputSection extends Vue {
  @Prop({ required: true }) public output: Output;
  @Prop({ required: true }) public copy: Copy;
  @Prop({ required: true }) public maxTotal: number;
  @Prop({ default: false }) public selected: boolean;
  @Prop({ default: 2 }) public currencyDp: number;
  @Prop({ default: 0 }) public percentageDp: number;

  public completed: boolean = false;
  public animate: boolean = false;
  public showEmployer: boolean = false;
  public showEmployee: boolean = false;
  public showEmployeeRelief: boolean = false;
  public showEmployeeReliefOverflow: boolean = false;

  public get time(): number {
    const time = getComputedStyle(document.body).getPropertyValue('--animation-time');
    return time ? parseInt(time, 10) : 1000;
  }

  public get relief(): number {
    return this.employee.contribution - this.output.netCost;
  }

  public get reliefPercentage(): number {
    return (this.relief / this.output.total) * 100;
  }

  public get employeeCost(): number {
    return (this.employee.contribution - this.relief);
  }

  public get employerPercentage(): number {
    return (this.employer.contribution / this.output.total) * 100;
  }

  public get totalPercent(): number {
    return (this.output.total / this.maxTotal) * 100;
  }

  public get employee(): OutputContribution  {
    return this.output.employee;
  }

  public get employer(): OutputContribution  {
    return this.output.employer;
  }

  public get employeeContributes(): number {
    if (this.showEmployeeRelief) {
      return this.employeeCost;
    }

    if (this.showEmployee) {
      return this.employee.contribution;
    }

    return 0;
  }

  public get employeeTop(): number {
    if (this.showEmployeeRelief) {
      return this.reliefPercentage;
    }

    if (this.showEmployee) {
      return 0;
    }

    return 100;
  }

  public get employeeContributesMessage(): string {
    if (this.showEmployeeRelief) {
      return this.copy.outputs.costToYou;
    }

    if (this.showEmployee) {
      return this.copy.outputs.employee;
    }

    return '';
  }

  public get currentTotal(): number {
    let total = 0;

    if (this.showEmployee) {
      total += this.employee.contribution;
    }

    if (this.showEmployer) {
      total += this.employer.contribution;
    }

    return total;
  }

  public get employerTop(): number {
    return this.animate ? 100 - this.employerPercentage : 100;
  }

  public get delayBetweenStacks(): number {
    return this.time / 5;
  }

  @Watch('output.visible', { immediate: true })
  public watchOutputVisible(visible: boolean) {
    this.animate = visible;
  }

  @Watch('employeeTop', { immediate: true })
  public watchEmployeeTop(visible: boolean) {
    this.setEmployeeReliefOverflow();
  }

  public setEmployeeReliefOverflow(delay = this.time) {
    const { employeeRelief, employeeReliefText } = this.$refs;

    _.delay(() => {
      if (employeeRelief && employeeReliefText) {
        const wrapperHeight = (employeeRelief as HTMLElement).offsetHeight;
        const textHeight = (employeeReliefText as HTMLElement).offsetHeight;
        this.showEmployeeReliefOverflow = wrapperHeight < textHeight;
      }
    }, this.delayBetweenStacks);
  }

  public afterStackAppear() {
    _.delay(() => {
      this.showEmployer = true;

      if (!this.output.employerMatch) {
        this.showEmployee = true;
      }

      this.$emit('afterStackAppear', this.output);
    }, 100);
  }

  public afterEmployerContributionEnter() {
    _.delay(() => {
      this.showEmployee = true;
      this.$emit('afterEmployerStack', this.output);
    }, this.delayBetweenStacks);
  }

  public afterEmployeeContributionEnter() {
    _.delay(() => {
      this.showEmployeeRelief = true;
      this.$emit('afterEmployeeStack', this.output);
    }, this.delayBetweenStacks * 2);
  }

  public afterEmployeeReliefEnter() {
    this.$emit('afterEmployeeReliefStack', this.output);
    this.$emit('completed', this.output);
    this.setEmployeeReliefOverflow(0);
    this.completed = true;
  }
}
